import { checkInsufficientAmountError } from '@src/domains/payments/core/checkInsufficientAmountError';

import type { PaymentValidationErrorFlags } from '@src/domains/payments/types/payment';

const GATEWAYS_MUST_MATCH = 'gatewaysMustMatch';
const BLOCKED_BUYER = 'blockedBuyer';
const TRANSACTION_ERROR_KEY = 'transactionError';

export const classifyPaymentValidationError = (errors: { [key: string]: string[] }): PaymentValidationErrorFlags => ({
  isPurchaseDisapproved: Boolean(errors[TRANSACTION_ERROR_KEY]),
  isGatewaysMismatch: errors['paymentMethodId']?.includes(GATEWAYS_MUST_MATCH) ?? false,
  isBlockedBuyer: errors['clientInfo']?.includes(BLOCKED_BUYER) ?? false,
  hasInsufficientAmount: checkInsufficientAmountError(errors),
});
